module.exports = __webpack_public_path__ + "img/whitePlus.23f15065.svg";